import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DiallerService } from '@app/dialler/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, merge, Observable, of } from 'rxjs';
import { map, scan, switchMap } from 'rxjs/operators';
import { LoggerService } from '@adreno-common';
import { CallbacksDto, CallbackSchedulesDto } from '../models';
import { WorkService } from '../services';
import { CallbackService } from '../services/callback.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-tasks',
  templateUrl: './tasks.component.html',
  styles: ['.btn-sm { line-height: 14px; border-radius: 4px; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TasksComponent {
  callbackCount: number = 0;
  initial = new BehaviorSubject<boolean>(true);
  page: number = 1;
  pageSize: number = 10;
  viewModel$: Observable<ViewModel>;
  windowHeight: number = window.innerHeight;

  constructor(
    public activeModal: NgbActiveModal,
    private workSvc: WorkService,
    private diallerSvc: DiallerService,
    private logger: LoggerService,
    private callbackSvc: CallbackService,
    private toastSvc: ToastrService
  ) {
    this.viewModel$ = this.initViewModel();
    this.initial.next(false);
    //this.workSvc.listUserCallbacks(0 - new Date().getTimezoneOffset());

    this.viewModel$.subscribe((vm) => {
      this.pageSize = (this.windowHeight - 350) / 50;

      this.callbackCount = vm.callbacks?.length!;
    });
  }

  private initViewModel() {
    return merge<Partial<ViewModel>>(
      this.callbackSvc.campaignSchedules$.pipe(
        map((campaignSchedules) => ({ campaignSchedules }))
      ),
      this.callbackSvc.userCallbacks$.pipe(
        map((callbacks) => ({
          callbacks,
        }))
      ),
      this.initial.pipe(map((initial) => ({ initial })))
    ).pipe(scan((acc, value) => ({ ...acc, ...value }), {} as ViewModel));
  }

  closeModal() {
    this.diallerSvc.nailOutAndLogout();
    this.workSvc.updateStateToGeneral();
    this.activeModal.close();
  }

  selectRecord(recordId: number, campaignId: number) {
    this.logger.debug('TasksComponent', 'selectRecord', {
      recordId,
      campaignId,
    })();

    this.callbackSvc
      .reserveCallback(recordId)
      .pipe(
        switchMap((success) => {
          if (success) {
            return of(success);
          } else {
            return this.callbackSvc.loadUserCallbacks().pipe(map(() => false));
          }
        })
      )
      .subscribe((success) => {
        if (success) {
          this.workSvc.popCallbackScript(recordId, campaignId);
          this.activeModal.close();
        } else {
          this.logger.warn(
            'TasksComponent',
            'selectRecord no longer available',
            { recordId, campaignId }
          )();
          this.toastSvc.warning('Callback no longer available.');
        }
      });
  }
}

interface ViewModel {
  callbacks: CallbacksDto[] | undefined;
  campaignSchedules: CallbackSchedulesDto | undefined;
  initial: boolean;
}
